// external dependencies
import React from 'react'
import styled from '@emotion/styled'
import { number, string } from 'prop-types'

const MarkerWrapper = styled.div`
	cursor: 'pointer';
	display: 'inline-block';
	height: ${({ height }) => height}px;
	left: calc(width / -2);
	position: 'absolute';
	top: height * -1;
	transform: scale(1, 1);
	transform-origin: ${({ height, width }) => `${width / 2}px ${height}px`};
	transition: 'transform 0.5s';
	vertical-align: 'middle';
	width: ${({ width }) => width}px;
	z-index: 'auto';
`

MapMarker.propTypes = {
	fill: string,
	height: number,
	innerFill: string,
	width: number,
}

/**
 * MapMarker used to mark the destination within the Map component
 *
 * @param {String} props.fill :: outter fill color of the location pin
 * @param {Number} props.height :: number of pixels the pin should be in height
 * @param {String} props.innerFill :: inner fill color of the location pin
 * @param {Number} props.width :: number of pixels the pin should be in width
 */
export function MapMarker({ fill = '#E7040F', height = 35, innerFill = '#FF725C', width = 24 }) {
	return (
		<MarkerWrapper height={height} width={width}>
			<svg width="100%" height="100%" viewBox="0 0 363.91 485.21">
				<path
					d="M242.8,0c-100.48,0-182,81.47-182,182A181.13,181.13,0,0,0,97.16,291L242.8,485.21,388.45,291A181.11,181.11,0,0,0,424.76,182C424.76,81.47,343.29,0,242.8,0Zm0,303.26A121.3,121.3,0,1,1,364.1,182,121.31,121.31,0,0,1,242.8,303.26Z"
					transform="translate(-60.85)"
					fill={fill}
				/>
				<circle cx="181.96" cy="182" r="121" fill={innerFill} />
			</svg>
		</MarkerWrapper>
	)
}
